// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import TableLoader from "@/components/TableLoader";
import DeviceBattery from '@/components/Units/DeviceBattery';
import Vuetify from "vuetify";
import UserModal from "@/components/Users/UserModal";
import underscore from "vue-underscore";
import * as utils from "@/utils/utils";
import * as VueGoogleMaps from "vue2-google-maps";
import wysiwyg from "vue-wysiwyg";
import VueFuse from 'vue-fuse'
import ReservationsModal from '@/components/Reservations/ReservationsModal';
Vue.component('reservations-modal', ReservationsModal);
import Planner from '@/components/Planner/Planner';
Vue.component('planner', Planner);

import {
	StatusIndicator
} from "vue-status-indicator";

require("../node_modules/vue-wysiwyg/dist/vueWysiwyg.css");
require("../node_modules/vuetify/dist/vuetify.min.css");
require("../node_modules/vue-status-indicator/dist/vue-status-indicator.css");


window.emitter = new Vue();
Vue.config.productionTip = false;
Vue.component("table-loader", TableLoader);
Vue.use(Vuetify);
Vue.use(VueFuse)
Vue.use(underscore);
Vue.use(utils);
Vue.use(wysiwyg, {
	hideModules: {
		table: true
	}
});

// todo verplaatsen
Vue.filter('toCurrency', function (value) {
	if (!value) {
		return '';
	} else {
		return utils.getFormattedAmount(value);
	}
})

Vue.use(VueGoogleMaps, {
	load: {
		key: "AIzaSyCgaCVWpKectL7lCRTC7oriHlBx7I_bV3w",
		libraries: "places",
		language: "nl"
	}
});

window.pullConfig = {
	errorLabel: "Error",
	startLabel: "Bijwerken..",
	readyLabel: "Laat los om bij te werken..",
	loadingLabel: "Gegevens op halen.."
};

/* eslint-disable no-new */
new Vue({
	el: "#app",
	router,
	template: "<App/>",
	components: {
		App,
		UserModal
	}
});


function getHiddenProp() {
	var prefixes = ["webkit", "moz", "ms", "o"];

	// if 'hidden' is natively supported just return it
	if ("hidden" in document) return "hidden";

	// otherwise loop over all the known prefixes until we find one
	for (var i = 0; i < prefixes.length; i++) {
		if (prefixes[i] + "Hidden" in document) return prefixes[i] + "Hidden";
	}

	// otherwise it's not supported
	return null;
}

window.addEventListener("load", function visChange() {
	sessionStorage.initialPlay = false;

	var visProp = getHiddenProp();
	if (visProp) {
		var evtName = visProp.replace(/[H|h]idden/, "") + "visibilitychange";
		document.addEventListener(evtName, reloadData);
	}

	// Reload data when tab was hidden
	function reloadData() {
		if (document[visProp]) {
			window.emitter.$emit("hidden");
			console.log('hidden')
		} else if (window.emitter) {
			// update reservations
			console.log('update')
			window.emitter.$emit("windowVisible");
			window.emitter.$emit("updateReservations");
			window.emitter.$emit("checkVersion");
		}
	}

	// Thunderpush
	//Thunder.connect("192.168.2.7:8000", "publickey", ["secret"], {log: false});
	//Thunder.listen(function(data) {  window.emitter.$emit('showPushNotification',{msg:data.msg, id: data.id});});

});



// WEBPACK FOOTER //
// ./src/main.js